export class Teetime {
    IDPrenotazione: number;
    IDRicevuta: number;
    NumeroRicevuta: number;
    AnnoRicevuta: number;
    ContactID: number;
    IDGolfclub: number;
    IDPartenza: number;
    DataPrenotazione: string;
    OraPrenotazione: string;
    DataPartenza: string;
    OraPartenza: string;
    IDPercorso: number;
    DescrizionePercorso: string;
    Status: string;
    Qty: number;
    Golfcar: number;
    Carrello: number;
    CarrelloElettrico: number;
    Sacca: number;
    GolfcarDisp: number;
    CarrelloDisp: number;
    CarrelloElettricoDisp: number;
    SaccaDisp: number;
    PrenotatoDa: string;
    Nome1: string;
    Nome2: string;
    Nome3: string;
    Nome4: string;
    Handicap1: string;
    Handicap2: string;
    Handicap3: string;
    Handicap4: string;
    Email1: string;
    Email2: string;
    Email3: string;
    Email4: string;
    Telefono: string;
    Note: string;
    RiceviSMS:  boolean;
    RiceviEmail:  boolean;
    Nazione: string;
    Login: string;
    IsDeletable: boolean;

    public Teetime() {
        this.IDPrenotazione = 0;
        this.IDRicevuta = 0;
        this.NumeroRicevuta = 0;
        this.AnnoRicevuta = 0;
        this.ContactID = 0;
        this.IDGolfclub = 0;
        this.IDPartenza = 0;
        this.DataPrenotazione = '';
        this.OraPrenotazione = '';
        this.DataPartenza = '';
        this.OraPartenza = '';
        this.IDPercorso = 0;
        this.DescrizionePercorso = '';
        this.Status = '';
        this.Qty = 0;
        this.Golfcar = 0;
        this.Carrello = 0;
        this.CarrelloElettrico = 0;
        this.Sacca = 0;
        this.GolfcarDisp = 0;
        this.CarrelloDisp = 0;
        this.CarrelloElettricoDisp = 0;
        this.SaccaDisp = 0;
        this.PrenotatoDa = '';
        this.Nome1 = '';
        this.Nome2 = '';
        this.Nome3 = '';
        this.Nome4 = '';
        this.Handicap1 = '';
        this.Handicap2 = '';
        this.Handicap3 = '';
        this.Handicap4 = '';
        this.Email1 = '';
        this.Email2 = '';
        this.Email3 = '';
        this.Email4 = '';
        this.Telefono = '';
        this.Note = '';
        this.RiceviSMS = false;
        this.RiceviEmail = false;
        this.Nazione = '';
        this.Login = '';
        this.IsDeletable = false;
    }
}
export class GetTeetimesReq
{
    store: string;
    myToken: string;

    constructor()
    {
        this.store = '';
        this.myToken = '';
    }
}
export class GetTeetimesResp
{
    error: string;
    teetimes: Teetime[];
    constructor()
    {
        this.error = '';
        this.teetimes = [];
    }
}
export class EliminaTeetimeReq
{
    store: string;
    myToken: string;
    prenotazioneId: number;

    constructor()
    {
        this.store = '';
        this.myToken = '';
        this.prenotazioneId = 0;
    }
}
export class ModificaTeetimeReq
{
    store: string;
    myToken: string;
    prenotazioneId: number;
    qty: number;
    golfcar: number;
    carrello: number;
    carrelloElettrico: number;
    sacca: number;
    nome1: string;
    nome2: string;
    nome3: string;
    nome4: string;
    email1: string;
    email2: string;
    email3: string;
    email4: string;
    handicap1: string;
    handicap2: string;
    handicap3: string;
    handicap4: string;
    note: string;

    constructor() {
        this.store = '';
        this.myToken = '';
        this.prenotazioneId = 0;
        this.qty = 0;
        this.golfcar = 0;
        this.carrello = 0;
        this.carrelloElettrico = 0;
        this.sacca = 0;
        this.nome1 = '';
        this.nome2 = '';
        this.nome3 = '';
        this.nome4 = '';
        this.email1 = '';
        this.email2 = '';
        this.email3 = '';
        this.email4 = '';
        this.handicap1 = '';
        this.handicap2 = '';
        this.handicap3 = '';
        this.handicap4 = '';
        this.note = '';
    }
}